import { type Corner, type LogLevelConfig } from "./types";

export const LOG_LEVELS: Record<string, LogLevelConfig> = {
  log: { color: "#666", emoji: "💬", label: "LOG" },
  info: { color: "#2196f3", emoji: "ℹ️", label: "INFO" },
  warn: { color: "#ff9800", emoji: "⚠️", label: "WARN" },
  error: { color: "#f44336", emoji: "❌", label: "ERROR" },
  debug: { color: "#9c27b0", emoji: "🔍", label: "DEBUG" },
} as const;

export const STORAGE_KEY = "mobile-console-position";
export const DEFAULT_CORNER: Corner = "bottom-right";

// UI Colors
export const COLORS = {
  // Background colors
  modalBackground: "rgba(0, 0, 0, 0.8)" as const,
  consoleBackground: "#1a1a1a" as const,
  headerBackground: "#2a2a2a" as const,
  logEntryBackground: "#333" as const,

  // Text colors
  primaryText: "white" as const,
  secondaryText: "#999" as const,
  mutedText: "#666" as const,

  // Button colors
  clearFiltersButton: "#ffd93d" as const,
  clearButton: "#ff6b6b" as const,

  // Border colors
  border: "#333" as const,

  // Stack trace color
  stackTrace: "#ff9999" as const,
} as const;
